import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HomePage } from './pages/home';
import { VerifyPage } from './pages/verify';
import { NotificationsPage } from './pages/notifications';

/** Backward compat: /?code=xxx → /verify?code=xxx */
function LegacyCodeRedirect() {
  const location = useLocation();
  const code = new URLSearchParams(location.search).get('code');

  if (code) {
    return <Navigate to={`/verify?code=${encodeURIComponent(code)}`} replace />;
  }

  return null;
}

export default function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <LegacyCodeRedirect />
            <HomePage />
          </>
        }
      />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/notifications" element={<NotificationsPage />} />
    </Routes>
  );
}
